module.exports = __webpack_public_path__ + "static/media/9a259b95-6956-4622-ac86-6d11c8d97a57.cb597f88.jpeg";